import { toast } from "sonner";
import { Share2, Facebook, Twitter, MessageCircle, Link as LinkIcon } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export default function ShareMenu({ item }) {
  const url = `${window.location.origin}/p/${item.highlight_id}`;
  const text = `${item.title || "Check this out"} — PaddleVerse`;
  const enc = encodeURIComponent;
  const open = (u) => window.open(u, "_blank", "noopener,noreferrer");
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); }
    catch (e) { toast.error("Couldn't copy the link"); }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: item.title, text, url }); } catch (e) { /* cancelled */ } }
    else { copy(); }
  };
  const canNative = typeof navigator !== "undefined" && !!navigator.share;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`share-btn-${item.highlight_id}`} className="inline-flex items-center gap-1 text-xs font-bold text-[#5C7285] hover:text-[#0E395F] transition-colors">
          <Share2 size={14} /> Share
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="share-menu">
        {canNative && (
          <DropdownMenuItem onClick={native} data-testid="share-native" className="cursor-pointer"><Share2 size={15} className="mr-2" />Share…</DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`)} data-testid="share-facebook" className="cursor-pointer"><Facebook size={15} className="mr-2" />Facebook</DropdownMenuItem>
        <DropdownMenuItem onClick={() => open(`https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(text)}`)} data-testid="share-twitter" className="cursor-pointer"><Twitter size={15} className="mr-2" />X / Twitter</DropdownMenuItem>
        <DropdownMenuItem onClick={() => open(`https://wa.me/?text=${enc(text + " " + url)}`)} data-testid="share-whatsapp" className="cursor-pointer"><MessageCircle size={15} className="mr-2" />WhatsApp</DropdownMenuItem>
        <DropdownMenuItem onClick={copy} data-testid="share-copy" className="cursor-pointer"><LinkIcon size={15} className="mr-2" />Copy link</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
